import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Marvel has an excellent framework to integrate its comics into a unified Marvel universe. Let's see if we can apply the same framework to `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Shanghai_Animation_Film_Studio"
      }}>{`Shanghai Animation Film Studio`}</a>{`'s movies and TV series to make another hero universe.`}</p>
    <h1>{`Titles for Framework Test`}</h1>
    <h3><a parentName="h3" {...{
        "href": "https://en.wikipedia.org/wiki/Calabash_Brothers"
      }}>{`Calabash Brothers`}</a></h3>
    <p>{`Seven brave kids fight snake woman and her minions to save grandpa & protect friends of gourdian mountain. Each gourdian kid has one super power, e.g. titanization etc... In later sequal, seven kids merges into one with seven super power.`}</p>
    <img {...{
      "style": {
        "width": "100%",
        "maxWidth": "30rem"
      },
      "alt": "",
      "src": "https://upload.wikimedia.org/wikipedia/en/3/37/Calabashbrothers.jpg"
    }}></img>
    <h3><a parentName="h3" {...{
        "href": "https://zh.wikipedia.org/wiki/%E9%98%BF%E5%87%A1%E6%8F%90%E7%9A%84%E6%95%85%E4%BA%8B"
      }}>{`Lengend of Effendi`}</a></h3>
    <p>{`This one is challenging. It's a mid-eastern legend story, without any super power! However, we could define its super power to be wisdom. Or some mytherous high dimensional ability like doctor strange.`}</p>
    <img {...{
      "style": {
        "width": "100%",
        "maxWidth": "30rem"
      },
      "alt": "",
      "src": "https://upload.wikimedia.org/wikipedia/zh/0/0f/%E7%94%B5%E5%BD%B1%E9%98%BF%E5%87%A1%E6%8F%90%E7%9A%84%E6%95%85%E4%BA%8B%E7%94%BB%E9%9D%A2.jpg"
    }}></img>
    <h3><a parentName="h3" {...{
        "href": "https://en.wikipedia.org/wiki/Three_Monks"
      }}>{`Three Monks`}</a></h3>
    <p>{`Very ancient story of three monks trying to refill water in temple. We could take water as their super power. It gives life for planets in universe and three monks are likely from high civilization that observe galaxy and trying to allocate limited water/life resources.`}</p>
    <img {...{
      "style": {
        "width": "100%",
        "maxWidth": "30rem"
      },
      "alt": "",
      "src": "https://upload.wikimedia.org/wikipedia/en/7/71/ThreeMonksAnimation2.jpg"
    }}></img>
    <h3><a parentName="h3" {...{
        "href": "https://zh.wikipedia.org/wiki/%E8%88%92%E5%85%8B%E5%92%8C%E8%B4%9D%E5%A1%94"
      }}>{`Adventure of Shulk & Beta`}</a></h3>
    <p>{`Mouse brothers has no super power but a bunch of self made helicopter and tank. We could give them super power like high tech genius.`}</p>
    <img {...{
      "style": {
        "width": "100%",
        "maxWidth": "30rem"
      },
      "alt": "",
      "src": "http://dalian.sinaimg.cn/2010/0903/201093133424.jpg"
    }}></img>
    <h3><a parentName="h3" {...{
        "href": "https://en.wikipedia.org/wiki/Black_Cat_Detective"
      }}>{`Blackcat Detective`}</a></h3>
    <p>{`Blackcat and his police force fight with mouse villains like `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`one ear`}</code>{` & `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`cat eater`}</code>{` to protect harmony of forest.`}</p>
    <img {...{
      "style": {
        "width": "100%",
        "maxWidth": "30rem"
      },
      "alt": "",
      "src": "https://upload.wikimedia.org/wikipedia/en/b/bd/BlackcatDetective.jpg"
    }}></img>
    <h1>{`Background Setup`}</h1>
    <p>{`To boostrap, we need to set the background of this universe (maybe even a parallel universe that could have connection to Marvel if later we got famous). Once you set it as an universe with so many aliens, it brings so much flexibility to connect across different titles and make your story logical and convincing. With such background, you can easily bring all heroes & heorines together to fight evil.`}</p>
    <p>{`Talking about evil, we need a big villain and a mainline story to fight with this evil. But we have experience that big villain need to have their own story to make it real. How about `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Thenos`}</code>{`?`}</p>
    <p>{`Now let's brainstorm the story and sorry I have to use my native language Chinese for best expressiveness...`}</p>
    <blockquote>
      <p parentName="blockquote">{`宇宙中，有一个早期的III级文明种族，Elesian。他们最早开始银河系的文明扩张，在扩张的过程中难免会有其他文明的冲突与融合。Elesian在鼎盛时期几乎占据了银河系80%的可居住星系。他们有高度的文明，采用一种类似分布式与中央集权的混合制度，是银河系令人敬畏的最高级文明。这个文明在外看上去很难用单一的思维去理解，因为治理的广度，他们对不同的地域的扩张采取不同的激进程度。`}</p>
    </blockquote>
    <p><em parentName="p">{`In the universe, an early Type III civilization called the Elesians were the first to begin galactic expansion. At their peak they controlled nearly 80% of habitable star systems in the Milky Way. A highly advanced civilization running a hybrid of distributed and centralized governance — awe-inspiring and hard to understand from the outside, because they applied different levels of aggression to different regions of expansion.`}</em></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "600px",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)"
      }
    }}>{`
      `}<a parentName="span" {...{
        "className": "gatsby-resp-image-link",
        "href": "/static/b3d3eb1b366f3b1b425148bc2de7d8f9/302a4/0001.png",
        "style": {
          "display": "block"
        },
        "target": "_blank",
        "rel": "noopener"
      }}>{`
    `}<span parentName="a" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "120.66666666666667%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAYCAIAAAB1KUohAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAC2klEQVQ4y51UWW8TMRDe//8neOMNofQBASKopNCSqmm72SSbc3N6D+/RvU/bYWynaRsqoWJtRo7tb76Zb8ZW9m8cjDEwMCGkVuR/sfQ2J5Q2/wfm5ymlymMk/wz1NHK2Z8rfG2VRNjDquipLsGVZvkoA3KdgQF5dXGxWy9ViMZ9MtsvlbrMeatr15a/NynjuhTKR8/ORZ5mm3s/GujGbeC4eqCr/7nrtT2fq7Q3HUPrEfAKu69oyTduyTIRc7PiemyRp+mB7zi6MwgOzVPgVcFV52A59L0+zky3S1HmWgArHAikvaStINU1imFjbzYPniTgJ2NB3dyvDQdvFVM/SRKw/gqUMtmmmSUIhIEaLPHctS+4C28aYyzNZls70gYS8AE/HIw/jm+71j3b7S6v1s/39qGK3c+5YqN+7DgN/PFCTOIJ15dhsYIcD7fPHD1BZ2tC1AaXSQQJYL/JMvfnt2sjHVuv9u95VR/R29SLnqiq/nrVCDyRzJrqONuuiyMU5Ykz0wHVg3u18CzwscsmVIgxpU8uwi6KYjoY22rkYT/Wxdn8vROaCPfjeVefc2m11tQeKQqxVkSgRV+VQd9/B1naXpfF2aQDVbDQ4yoFtNLjjTbKaj+djTRQ1U4o0tRFyLAubpu+6hBKoRBQEoILvOHEINXJvu5fYNiF4yTEd9fu33SKPFb2vRUEYB2FT1YempbTIMkpoHAYQYRJFi/FoOtL28ioxHibaGJOhqqDF6hgb4IEKisHzzzKYJEkkm3k1nz72Rs1oUxb5XB8oEXYoaSi/2w2hDeBhA/4BIVovxe2hwAeFYHCMEkKheJCR6TpIIXUOONnoTV0xPgc/TZkX2EIyCybwMkB4usAFkIBVBKYmcITwRf6rSzCMcBfcF2XPhwBLBnGrJDNEDQ75y0gAQPaC7/Cxpwm4pIyI9qcKNAYRj07Dedj+eN/kxeWNy3gfCAtOGWuE4PwZ+wOHpGN8d3BhkQAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="a" {...{
          "className": "gatsby-resp-image-image",
          "alt": "0001",
          "title": "0001",
          "src": "/static/b3d3eb1b366f3b1b425148bc2de7d8f9/0a47e/0001.png",
          "srcSet": ["/static/b3d3eb1b366f3b1b425148bc2de7d8f9/8a4e8/0001.png 150w", "/static/b3d3eb1b366f3b1b425148bc2de7d8f9/5a46d/0001.png 300w", "/static/b3d3eb1b366f3b1b425148bc2de7d8f9/0a47e/0001.png 600w", "/static/b3d3eb1b366f3b1b425148bc2de7d8f9/1cfc2/0001.png 900w", "/static/b3d3eb1b366f3b1b425148bc2de7d8f9/302a4/0001.png 1080w"],
          "sizes": "(max-width: 600px) 100vw, 600px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
  `}</a>{`
    `}</span>
    <blockquote>
      <p parentName="blockquote">{`我们的大反派Thenos新诺斯，银河系Betelgeuse星系的泰坦族，早年因Elesian的激进扩张入侵，目睹父亲和亲人被Elesian迫害之死，心中种下了仇恨的种子。`}</p>
    </blockquote>
    <p><em parentName="p">{`Our villain, Thenos, is a Titan from the Betelgeuse system. As a child he witnessed his father and family persecuted to death during the Elesian aggressive expansion — and that's where the seed of hatred was planted.`}</em></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "600px",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)"
      }
    }}>{`
      `}<a parentName="span" {...{
        "className": "gatsby-resp-image-link",
        "href": "/static/f1c778ba5dbee28c44d984df46a388f7/9239a/0002.png",
        "style": {
          "display": "block"
        },
        "target": "_blank",
        "rel": "noopener"
      }}>{`
    `}<span parentName="a" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "86.66666666666667%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAIAAABSJhvpAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAC3klEQVQ4y11TW3OaQBTm5+e9fe5M+9JpJm06Mc3dVANG0HiLNxSUIILcLyICywI9iM10urNzWHb3O3vO+b5DZFmW53lpU5RkaQoT/m3Lsk0z8P0EofJCCvuHgRDyHAcWRHlwHIAsPxg7pqVtlHfAvwNuYIzBEv8duLYDXgG8kWRZkt7jKn3COgz3MMvNAoxipCqyZRhBsANAr/2Ck+T24qLDMHC63W7jOC69xFE06vd0VSnxBXjrOjw7qd1dMxTJz2aDlzZkdfr5i2vZtmWSj1VdVd+W/D4IIP9Wg2TIuiKJR7BjmiLPzccjRVo93t7UqtXJ8LVDN+W1tORmtesrcck/16ueY8NlmvzNT0fymxDHUQGOw7DbfNbWa8fQl/y83WyuBaFMU+A5hnpiGhRN1seDvsBxHZocdVuSsDi+jBOsK0q48wPPjYIdBAJxQqkt3UARUhS5TBjhBBw9VH5ykxEU5W/OnrcSltE+2Ac7sC2SpCnq8sfZ/eUvbspKomhZhu9vIefZZATvi8tFSSGRJIksrQxVybMUAdT37iuV8eD1/PQry07Z8bjPNB3LwChK4ghkM3kdDLudI1XbrWeZhqVpuio7pg43GtUHgedpkoQ3ucmYrj2iKHJNw3cdTZHHvd5Glgo5pikRhaGpqeBb4OcCN2s3KKgt+XD36eOHDycn1+dnsvTGDnutxpNtmz3medrvxtEewgTNEGB9191Ikrjg0iRR15Iwm7SpeuX7N5p6qt5caRu5xzRc2/S3Xr9NA2GmtilVd+BZU9pkTVXWOUYQm8DN9Y28mLMcO7UMDcUx8A/yAM0G/g5EFodBliYIeM4KngNVXGYpPmjb9D0XYxTud0DeDtRnGp7rQC3zQ4WTOAYvkDBY4tiNeb5zjMVkqK1FXRaNjVxU0dC19QrW4AhcpwcEdNShZyHKhADRg0iAMFTEs8cIfsE3StME+qjwXPQThiYs8cVmCps50PoHbWSnHZZATWEAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="a" {...{
          "className": "gatsby-resp-image-image",
          "alt": "0002",
          "title": "0002",
          "src": "/static/f1c778ba5dbee28c44d984df46a388f7/0a47e/0002.png",
          "srcSet": ["/static/f1c778ba5dbee28c44d984df46a388f7/8a4e8/0002.png 150w", "/static/f1c778ba5dbee28c44d984df46a388f7/5a46d/0002.png 300w", "/static/f1c778ba5dbee28c44d984df46a388f7/0a47e/0002.png 600w", "/static/f1c778ba5dbee28c44d984df46a388f7/1cfc2/0002.png 900w", "/static/f1c778ba5dbee28c44d984df46a388f7/c1b63/0002.png 1200w", "/static/f1c778ba5dbee28c44d984df46a388f7/9239a/0002.png 1246w"],
          "sizes": "(max-width: 600px) 100vw, 600px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
  `}</a>{`
    `}</span>
    <blockquote>
      <p parentName="blockquote">{`长大后Thenos领导各路阿雷西亚的反抗势力推翻了Elesian在泰坦星系的统治，并夺取了Elesian的扩张武器Caliber（克隆兵工厂）的控制权，之后开启了Purifying计划，大清洗阿雷西亚族人，甚至包括支持和平繁荣的温和Elesian。`}</p>
    </blockquote>
    <p><em parentName="p">{`Growing up, Thenos led resistance forces across the Elesian factions to overthrow Elesian rule in the Titan system and seize control of their expansion weapon Caliber — a clone army factory. He then launched the Purifying Plan, a great purge of the Elesian people, including even the moderate Elesians who supported peace.`}</em></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "600px",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)"
      }
    }}>{`
      `}<a parentName="span" {...{
        "className": "gatsby-resp-image-link",
        "href": "/static/e4571313ef024ece689bfd3f813f77af/2cefc/0003.png",
        "style": {
          "display": "block"
        },
        "target": "_blank",
        "rel": "noopener"
      }}>{`
    `}<span parentName="a" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "77.33333333333333%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAIAAABr+ngCAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACZElEQVQoz3VSa2+bMBTN//8Xm1RpHzbtS6O1W5NMfWVKu7aERyAkBAKEQIAQg3kY2+xCsq6aNssyNvLxPeee02u6wRgr8rzhDecMjpRSWLMsjcOwhP//Gb3jB27vgm2KDig5tDCURrudJsuBt7VMI0n2WYoYo/8G5zj3XGc5V23TzNIMJcnLw4/+50/KVLgefLsZDTzHDgMfbnLO/wYDZ1WaaopkW8bTZKwp4vDi/MP7d9JUUCXxqn++0FRVFDe2Fe+Co0x45QQuCwALhq5psji5+a5JwvBL/+PZma6p49vrq35fk0ThcbLUlJWuHuvzN7Qz21z5nrOPQl2ZzURxtdRHlxfXo8Hw6ttMEl8eJ8ZcDYMtqYoOyjhjJzCcKCWwcWzrdjSc3N8JT4+gYvj1UhaFuaYmceRvnK1jUVI14AhrZ+9VfV3XCCF5KtwNB+LzTyjlrq2t67iWuXFtjNMcJaTMU5SANbw1lf8B5xiDT8ZiIT0/P9zfrc1Vhg6MEtdaRYFPGYXKrCY42RPScgTivSPp1ts01VVQFSw07WE81tVZjtNjL7MMoX3sey4p8M5ZUYJZXXFGe6/Wufba0OfmcjlX5MD392Gkz2bpIQFsmeO1aRziCGiHW5e33YEg0t9WlSUIg4Y7a8u1HU2W4EXggvaHAudlUaBkv160JmGEKCk7MOsdy1ZVFYW7NuFFPhOnS1XZuvbbMFVleYjCTmrdQE4Zhc2JNgzf20C2fc+Dt8FSlLYh50dPuzzxzk9Wl5RkIJgx0sM4J1UJoYc1iWPadRJaRGsK0E7aaUJ7O4cbXlNOWUP5L+hcRGAvC0BOAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="a" {...{
          "className": "gatsby-resp-image-image",
          "alt": "0003",
          "title": "0003",
          "src": "/static/e4571313ef024ece689bfd3f813f77af/0a47e/0003.png",
          "srcSet": ["/static/e4571313ef024ece689bfd3f813f77af/8a4e8/0003.png 150w", "/static/e4571313ef024ece689bfd3f813f77af/5a46d/0003.png 300w", "/static/e4571313ef024ece689bfd3f813f77af/0a47e/0003.png 600w", "/static/e4571313ef024ece689bfd3f813f77af/1cfc2/0003.png 900w", "/static/e4571313ef024ece689bfd3f813f77af/c1b63/0003.png 1200w", "/static/e4571313ef024ece689bfd3f813f77af/2cefc/0003.png 1400w"],
          "sizes": "(max-width: 600px) 100vw, 600px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
  `}</a>{`
    `}</span>


    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "600px",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)"
      }
    }}>{`
      `}<a parentName="span" {...{
        "className": "gatsby-resp-image-link",
        "href": "/static/a7f1c446197662306bf4fe1ed915095c/cb9f4/0009.png",
        "style": {
          "display": "block"
        },
        "target": "_blank",
        "rel": "noopener"
      }}>{`
    `}<span parentName="a" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "56.666666666666664%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAIAAADwazoUAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAB/0lEQVQoz1VR227aQBD15/etX1CpD5XSpulLGiWiLRXEaiFAwTFgBxt8v2B8W2zj9a69pkNIq/ZotRrtzpwzM4c7ntACjv8jicIK4+dP1v5BTcnxHDR5VWy5v9m4LCG7KjFrmKPrV2/fDHrdY/vCDbdnGWO+m0YhxARHB2SeilGS+I5jrlVzo3qmgeLo57cvfOdOV2RH3+CyKLIs3++FIT/o3initG0bWqEq97mmaaIgWMuyb9u+ZcbBForF0cBeqyiJlaWoK1L/9nrc7z4JE2U+0ySxLHLWlKRMuSjYUUJyhJT53DUMR9Pyfeoa+pjv8V9vfceG1rI0QXGoyZCwtjYrSnBd5Xlkc+E2iHa7wHNtbZOG253n5Cgd3fduri7F6RD6Og9MSaWvZM/S5+MfLatrnLiLKadKS9+2bF33LQNWUub70X3/88cP0mwK+s+rZVBc5Jn2JMFQ1kZlDW1o4S8nHCxj53sZSmtCDllGKhwFviwIvm1CF/+aBz7VlJ4CgltGXXH4YhWM3TQ1gJyCxtU1IDoURb5HpKoYY0AKN3gJL1HgZqH7cP2eO4+UxrH0+ChOJ8ZmDStQFouVOBdGY0mYZQj5jrWcTcRfo7W8fOC/dz5ddC7eXb5+xdGaMtaCJlCCo6BDQKUsQRZjTCkFdugLHuDADy4PNQWfMnXC/waw6Fp9FsLjwQAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="a" {...{
          "className": "gatsby-resp-image-image",
          "alt": "0009",
          "title": "0009",
          "src": "/static/a7f1c446197662306bf4fe1ed915095c/0a47e/0009.png",
          "srcSet": ["/static/a7f1c446197662306bf4fe1ed915095c/8a4e8/0009.png 150w", "/static/a7f1c446197662306bf4fe1ed915095c/5a46d/0009.png 300w", "/static/a7f1c446197662306bf4fe1ed915095c/0a47e/0009.png 600w", "/static/a7f1c446197662306bf4fe1ed915095c/1cfc2/0009.png 900w", "/static/a7f1c446197662306bf4fe1ed915095c/c1b63/0009.png 1200w", "/static/a7f1c446197662306bf4fe1ed915095c/cb9f4/0009.png 1903w"],
          "sizes": "(max-width: 600px) 100vw, 600px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
  `}</a>{`
    `}</span>
    <h1>{`Gourdian/Calabash Brothers`}</h1>
    <p>{`This Gourdian's background story is very close to mainline story:`}</p>
    <blockquote>
      <p parentName="blockquote">{`面对文明的毁灭，阿雷西亚的科学家，向银河系各地发出种子胶囊(Seeds)，里面包含了阿雷西亚最强的基因技术。这些基因胶囊记录了Elesian最优秀的超能基因，在银河系的偏远地区寻找可以播种发芽的机会。其中一颗在公元前掉落到地球中国的葫芦山。`}</p>
    </blockquote>
    <p><em parentName="p">{`Facing the annihilation of their civilization, Elesian scientists scattered seed capsules across the galaxy — each containing their most advanced genetic technology, encoding the finest superhuman genes of the Elesians, searching for fertile ground in the far reaches of the galaxy. One such capsule fell onto Gourd Mountain in ancient China.`}</em></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "600px",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)"
      }
    }}>{`
      `}<a parentName="span" {...{
        "className": "gatsby-resp-image-link",
        "href": "/static/782813f1bd1fd95f04898a56f6eeef7a/01ccc/0005.png",
        "style": {
          "display": "block"
        },
        "target": "_blank",
        "rel": "noopener"
      }}>{`
    `}<span parentName="a" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "77.33333333333333%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAIAAABr+ngCAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACEElEQVQoz3VTv2/TQBT2H8XEBjMjExsbSGwIiQ3BghiQkBiYELABqhAFNYKBoYJQlIpGaYubtG4SiO3Uvvi3Y1/u7p15Z7tOUMvTyXr37n3vfffds1YUhSwNHRBcClFu6khjEkAtKRnNOaOcxTR1tfqsTlXHKgdkU/GMScZyRqM8JdpqBmL4YgFwClWFAOOCc+JMI98PPOITByOcpYucLDurRICIzJIgUBxKQydNEn1n2xwdjg/7vuu8f/uytf4a4XnS0AYQDO+S28cD/WeHc14x4oyND/TAsfG41/kReWRj/c2Vyxd+db8Bj7SSlXBsG4m5lrn1eWPz4zvPdaqinnMSnkxi4kS4vBleypla927fvHP9qnW8q1UMkds8jq3hcLfdnlkmzTPVlnPX/EPTIPFInibzKEQwxtufPly7dLG71V4RTCq15mFIs3kVoHmOXGKPJIGPQUYzwReM0ng2vX/rxmarVYMbbZttBbaGBjZEUhIEIlEVz7XtSf/F00e9zvcVtRs81B5+JkMj9N0kCnB+OFtkaYq5a6+ePX5wF6+lLR95xQqoX9hziaHvxf5MDR9WE5BF/vMnD43+Pp6eD15WkcVBrzvY6yHzOEThJ9tfv5gjQ8nMxRkwrEBPfev3SO/tHOn746NBHJYjxBkAOw8MSBuKasLL/+Hf0ZbAS11AaFmW8dLk/62Z9mpmmzZ/AUWMUW/Wr0GQAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="a" {...{
          "className": "gatsby-resp-image-image",
          "alt": "0005",
          "title": "0005",
          "src": "/static/782813f1bd1fd95f04898a56f6eeef7a/0a47e/0005.png",
          "srcSet": ["/static/782813f1bd1fd95f04898a56f6eeef7a/8a4e8/0005.png 150w", "/static/782813f1bd1fd95f04898a56f6eeef7a/5a46d/0005.png 300w", "/static/782813f1bd1fd95f04898a56f6eeef7a/0a47e/0005.png 600w", "/static/782813f1bd1fd95f04898a56f6eeef7a/1cfc2/0005.png 900w", "/static/782813f1bd1fd95f04898a56f6eeef7a/c1b63/0005.png 1200w", "/static/782813f1bd1fd95f04898a56f6eeef7a/01ccc/0005.png 1399w"],
          "sizes": "(max-width: 600px) 100vw, 600px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
  `}</a>{`
    `}</span>
    <blockquote>
      <p parentName="blockquote">{`同时，Thenos也向银河系浪人和海盗开出了种子胶囊的悬赏通告，一群由蛇女Serpentia领导的星际海盗把搜索定位到了太阳系……`}</p>
    </blockquote>
    <p><em parentName="p">{`Meanwhile, Thenos put out a bounty across the galaxy for the seed capsules. A crew of space pirates led by the snake-woman Serpentia tracked one down to our solar system...`}</em></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "600px",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)"
      }
    }}>{`
      `}<a parentName="span" {...{
        "className": "gatsby-resp-image-link",
        "href": "/static/f96674b59010a28a58549a4c506c2de8/0d390/0010.png",
        "style": {
          "display": "block"
        },
        "target": "_blank",
        "rel": "noopener"
      }}>{`
    `}<span parentName="a" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "73.33333333333334%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAIAAABr+ngCAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACPklEQVQoz4VT2W7aQBTl/z+j75EqtSpBVVWyKBCgmNVgbBzCaoPt8ezjZZxcY0oUqVJHlj2+c85dz9Te/reKQqdpwhnhFCvJi6K4HtWumOqjC611nqWJUhKgjMRRcIxRCDvBMKcoS9UnMkAlJ0ARLAb3eZZRHFESwxGQCY4hWBWwOK/P5CwjOBIUcRpnWSo4AwQKfNscnrwtuPvIrtDlU6ZZPjXAKcHSFF4kVbKkhUcA+tvVfeOrt3tlBF/ilcwcErzyazo//5fJS52nULAuV+bMR8Pew3Zll5H/lfNHw8DKoTx0oiTC0XG7WliT3mLaX0wMwQlGETQMYHmeLxfTag+UqmGpYBTaXGhwrGN02r7a1qQ76T14G1cpsbTGy/kIYEqK25svs2H3EhnGyEiA/B10qzIBdD7t2YuxbRrHwzrwd+ag03lsxCiITp7Zb81HPSV4SZaCcRrSyIf0KvLUaLd+fzc6zf3aITgwB+1+qzl4bvqHDVhca+LMx4kSJRkFe8lL6YAiUOhzTtrN+n39pnN365h/BEPQAm/34lpDxojk1NutbGsM0jinrTWNQ9hZ427r17f56Ll9X39xZlPjab+2leLHwwZmDkILggMKPCm5722gc1XNb3FwiPzN5sXqNn+4M+P5od6+azimgXEYnry1a+M47D/+dGeDw8ohoX8WcV7o5CJPd9afGU84PIJ6wf1+vSRxUKpS6yRJYFYcR1CnzvI8Tf4OvKjBWZZmUkrB6edLUlxvy1WcV4VXlndyw0zVPLFzKAAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="a" {...{
          "className": "gatsby-resp-image-image",
          "alt": "0010",
          "title": "0010",
          "src": "/static/f96674b59010a28a58549a4c506c2de8/0a47e/0010.png",
          "srcSet": ["/static/f96674b59010a28a58549a4c506c2de8/8a4e8/0010.png 150w", "/static/f96674b59010a28a58549a4c506c2de8/5a46d/0010.png 300w", "/static/f96674b59010a28a58549a4c506c2de8/0a47e/0010.png 600w", "/static/f96674b59010a28a58549a4c506c2de8/1cfc2/0010.png 900w", "/static/f96674b59010a28a58549a4c506c2de8/c1b63/0010.png 1200w", "/static/f96674b59010a28a58549a4c506c2de8/0d390/0010.png 1472w"],
          "sizes": "(max-width: 600px) 100vw, 600px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
  `}</a>{`
    `}</span>
    <blockquote>
      <p parentName="blockquote">{`基因胶囊会通过纳米感知接触收集星球的高等生物进行融合，一开始掉落在了葫芦藤上吸收了其基因，后来吸收了来这里浇水施肥的中国爷爷的DNA，相貌上也继承了中国爷爷年少的样子。宇宙海盗曾一度被基因胶囊控制的葫芦所制服吸收，但是被一只穿山甲给放了出来，也就有后面的故事。`}</p>
    </blockquote>
    <p><em parentName="p">{`The seed capsule uses nano-sensing to fuse with the highest life forms it touches. It first absorbed the genes of the gourd vine it landed on, then the DNA of the old Chinese grandpa who came to water it — inheriting his young likeness in appearance. The space pirates were briefly subdued and absorbed by the capsule-controlled gourds, but were freed by a pangolin — and that's where the story really begins.`}</em></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "600px",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)"
      }
    }}>{`
      `}<a parentName="span" {...{
        "className": "gatsby-resp-image-link",
        "href": "/static/e12e4079769deaf6fd58e8e44ce29ea6/78958/0006.png",
        "style": {
          "display": "block"
        },
        "target": "_blank",
        "rel": "noopener"
      }}>{`
    `}<span parentName="a" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "82%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAIAAACZeshMAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAB60lEQVQoz41TWY/TMBDu/3/jER5XK944pBUCVQtCpduihW5pmqbZHE1zuolzOGcT5yiTFFiylMLIsuzxfHN+Hhz6Upa0aerD/8ng0R3vdN+1i33agA+Qqmq1TfNvMBhjW5fWC3Y2lTnGd6yyzEFfVSVxd0kYnAY3nW+8M4X1XN+K0ppRJV5XhCT2j68x8SLinYu8zxJN4R1LA+uSFjK/9DBybVNkv4jLzyXNz4LTWBFZcyvu08THyNI3W4kTuPnN9atP754TD3VZQBfq4+qBaZErEgvWy9mEX0xVeZ0lUVFkq2+Tj28uVZH5VeDpblumcjserua3piZEoZfGgedYpiavFuOQOH9NG0bT2qniRmAVgUOG2h5EVr5nQGlo94GPztXs4x3SpDDAEErk7kxVwsiAnXh2loZIE/dJfAIMkywpDT2cxSG4gBTSmKQJJG3D2UFaFLjEtW1jU+TZYzC8IU32XSTzC+iwpUmei8qaAkkqChMMowDnWZzFAZCuB4ZYLjJ817F05eb91YvLZxdPn7x9eTH5cNXxvMfNpnno96BjZQWUgHyBHsvZeDoaTkbXo+Fr5uv4wb7DdOu3UQGfj38Aqs6zFNtGRDpKtkyvf5o2/cg/rgNCCKW0aIXWVX1ofdctjdr9z7/ZK+E7Ew+OMeIEDLkAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="a" {...{
          "className": "gatsby-resp-image-image",
          "alt": "0006",
          "title": "0006",
          "src": "/static/e12e4079769deaf6fd58e8e44ce29ea6/0a47e/0006.png",
          "srcSet": ["/static/e12e4079769deaf6fd58e8e44ce29ea6/8a4e8/0006.png 150w", "/static/e12e4079769deaf6fd58e8e44ce29ea6/5a46d/0006.png 300w", "/static/e12e4079769deaf6fd58e8e44ce29ea6/0a47e/0006.png 600w", "/static/e12e4079769deaf6fd58e8e44ce29ea6/1cfc2/0006.png 900w", "/static/e12e4079769deaf6fd58e8e44ce29ea6/c1b63/0006.png 1200w", "/static/e12e4079769deaf6fd58e8e44ce29ea6/78958/0006.png 1320w"],
          "sizes": "(max-width: 600px) 100vw, 600px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
  `}</a>{`
    `}</span>
    <blockquote>
      <p parentName="blockquote">{`由此葫芦兄弟的冒险故事展开…… 故事被当成神话传说传承了下来。`}</p>
    </blockquote>
    <p><em parentName="p">{`And so the adventure of the Calabash Brothers began... a story passed down through generations as myth and legend.`}</em></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "600px",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)"
      }
    }}>{`
      `}<a parentName="span" {...{
        "className": "gatsby-resp-image-link",
        "href": "/static/988207f428467dc8706282711c717af6/3c1e5/0007.png",
        "style": {
          "display": "block"
        },
        "target": "_blank",
        "rel": "noopener"
      }}>{`
    `}<span parentName="a" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "37.99999999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAIAAAB2/0i6AAAACXBIWXMAAA7EAAAOxAGVKw4bAAABWUlEQVQY01WRb2+CMBDG+f6fZK99tWxLlsxEk02DE5hVqgjYAgXkfwtYYIeZ23zSF73r3T2/tspwVS2qvu9+901TD3fq/23+lgKJLImtnc7LohacV+Xs9XG/1Y97VBZ5mWdZGkNeVCUU3A8aFHlpGbEP6NMyja22XEyfXiYP0+eJ+v5mYWSi9Wa9wNrSUGdHbEAxr/IbY680tYgDEjNKbOy7lnNASFuuPqaug31ibw0V6Yuv1dxQ566F2qau8qRtxdjad4qUF86LIj/DyIhR5p+igATUOdn7MCAYrS1sHE2dUcfdI8HLa9tILutSubRNEnlnRvM0Zp5r7Qy4sLnRDqaRJVEU0MBzqb0LiJWdGWD3o0bsJk8UIMnTaLSldiOKcLR1PeJkSch8AgOpg9PYD6ldlUnb8NG568BatkIBEjC/YvChkx0c/KiTcgzh/QWvoAZiyN2+DNR+A6XpvxJuLzpTAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="a" {...{
          "className": "gatsby-resp-image-image",
          "alt": "0007",
          "title": "0007",
          "src": "/static/988207f428467dc8706282711c717af6/0a47e/0007.png",
          "srcSet": ["/static/988207f428467dc8706282711c717af6/8a4e8/0007.png 150w", "/static/988207f428467dc8706282711c717af6/5a46d/0007.png 300w", "/static/988207f428467dc8706282711c717af6/0a47e/0007.png 600w", "/static/988207f428467dc8706282711c717af6/1cfc2/0007.png 900w", "/static/988207f428467dc8706282711c717af6/c1b63/0007.png 1200w", "/static/988207f428467dc8706282711c717af6/3c1e5/0007.png 2854w"],
          "sizes": "(max-width: 600px) 100vw, 600px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
  `}</a>{`
    `}</span>
    <p>{`To Be Continue...`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      